import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Button, Spinner } from '@atomic';
import { Notice, AuthInput } from '@domain';
import { ReactComponent as LogoTypo } from '@assets/logo/logo_typo.svg';
import { IdIcon, LockIcon } from '@assets/icon';
import { MediaQueries, BREAKPOINT_PHONE } from '@style/MediaQuery';
import { useUserContext } from '@contexts/UserContext/UserProvider';
import { useForm } from '@hooks';
import { USER_LOGIN } from '@contexts/UserContext/types';

const LoginWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const InnerContainer = styled.div`
  max-width: 740px;
  min-height: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #e4e4e4;
  border-radius: 24px;

  ${MediaQueries(BREAKPOINT_PHONE)} {
    max-height: none;
    border: 0;
  }
`;

const Logo = styled(LogoTypo)`
  width: 160px;
  height: 160px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 420px;
  width: 100%;
`;

const Login = () => {
  const { onAuth, isLoading } = useUserContext();
  const [isCheck, setIsCheck] = useState(false);
  const { errors, handleChange, handleSubmit } = useForm({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: async (values) => {
      try {
        await onAuth({ values, type: USER_LOGIN });
      } catch (e) {
        setIsCheck(true);
      }
    },
    validate: ({ email, password }) => {
      const errors = {};
      if (!email) errors.email = '이메일을 입력해주세요.';
      if (!password) errors.password = '비밀번호를 입력해주세요.';

      return errors;
    },
  });

  return (
    <LoginWrapper>
      <InnerContainer>
        <Logo />
        <Form onSubmit={handleSubmit}>
          <AuthInput
            icnUrl={IdIcon}
            name="email"
            inputType="form"
            placeholder="아이디를 입력해주세요."
            onChange={handleChange}
            errorMessage={errors.email}
          />
          <AuthInput
            icnUrl={LockIcon}
            name="password"
            type="password"
            placeholder="비밀번호를 입력해주세요."
            onChange={handleChange}
            errorMessage={errors.password}
          />
          <Notice auth="login" isCheck={isCheck} />
          <Button
            onClick={handleSubmit}
            width="100%"
            height="50px"
            type="submit"
            disabled={isLoading}
          >
            로그인 {isLoading ? <Spinner /> : ''}
          </Button>
        </Form>
      </InnerContainer>
    </LoginWrapper>
  );
};

export default Login;
